<template>
    <v-container fill-height fluid class="contacto">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-container pa-2 grid-list-md>
                        <v-layout row justify-space-between>
                            <v-flex xs10 class="text-left">
                                <div
                                    class="text-left display-1 font-weight-bold brown--text text--darken-4"
                                >Atención a Centros de Consumo</div>
                            </v-flex>
                            <v-flex xs2 class="text-right">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn text @click="onClose" v-on="on">
                                            <v-icon>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cerrar</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider>

                        <v-layout row>
                            <v-flex xs12 class="text-center">
                                <iframe
                                    id="player"
                                    allowfullscreen="1"
                                    allow="autoplay; encrypted-media"
                                    title="YouTube video player"
                                    src="https://www.youtube.com/embed/nwYdIu24b-s"
                                    :width="playerSize.width"
                                    :height="playerSize.height"
                                    frameborder="0"
                                ></iframe>
                            </v-flex>
                            <v-flex xs12 class="text-center">
                                <iframe
                                    width="620"
                                    height="670"
                                    src="https://sibforms.com/serve/MUIEAIl7SLj0CrbcJvmG6fR7WkEDTal9xfwGihHk-bQTS5fpsXKvMHGFdbPrz1U2YmCX0ZR4EE8AkUQ69jim8frCahgua6ST8hlj7yGe-4Sw99p6-HkwCC6ENUHe2Yna10ryS9MwQ0kMDOAxSb1ryeLt_9UutyaAB0psQR7_tsE3iirlRv9WvEWi1CISLTT6sorXR2TJd7SYA-RV"
                                    frameborder="0"
                                    scrolling="auto"
                                    allowfullscreen
                                    style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"
                                ></iframe>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
                <!-- </section> -->
            </v-flex>
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- </v-parallax> -->
    <!-- </div> -->
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'contacto',
    data() {
        return {};
    },
    beforeRouteLeave(to, from, next) {
        next();
    },
    created() {},
    computed: {
        ...mapGetters(['waitCursor', 'navMainLogo']),

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '30%';
            }
            return width;
        },
        iFrameWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '258';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '388';
            } else if (this.$vuetify.breakpoint.md) {
                width = '620';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '817';
            } else {
                width = '1230';
            }
            return width;
        },
        iFrameHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '155';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '233';
            } else if (this.$vuetify.breakpoint.md) {
                height = '372';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '490';
            } else {
                height = '738px';
            }
            return width;
        },

        breakPoint() {
            var bkPoint = 'xs';
            if (this.$vuetify.breakpoint.sm) {
                bkPoint = 'sm';
            } else if (this.$vuetify.breakpoint.md) {
                bkPoint = 'md';
            } else if (this.$vuetify.breakpoint.lg) {
                bkPoint = 'lg';
            } else if (this.$vuetify.breakpoint.xl) {
                bkPoint = 'xl';
            }
            return bkPoint;
        },

        playerSize() {
            var size = {
                width: 620,
                height: 370
            };
            if (this.$vuetify.breakpoint.xs) {
                size.width = 420;
            } else if (this.$vuetify.breakpoint.sm) {
                size.width = 520;
            } else if (this.$vuetify.breakpoint.md) {
                size.width = 820;
            } else if (this.$vuetify.breakpoint.lg) {
                size.width = 920;
            } else {
                size.width = 1120;
            }
            size.height = size.width / 1.67567;
            return size;
        }
    },
    methods: {
        onFacebookSantaFe() {
            window.open('https://es-la.facebook.com/CatabocataMX');
        },
        onFacebookAvandaro() {
            window.open('https://www.facebook.com/CATABOCATAavandaro/');
        },
        onClose() {
            this.$router.push('/');
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0;
    opacity: 0.3; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.3);
}
.contacto {
    background: url('../assets/kym-ellis-aF1NPSnDQLw-unsplash1.png');
    background-size: cover;

    background-size: cover;
    width: 100%;
    height: 100%;
}
.bourbon {
    font-family: 'bourbon';
    font-weight: bold;
}

.catabocata-red {
    color: #bc1212;
}

.mainMenu {
    font-size: 80px;
}

.cata_2 {
    font-family: bourbon;
    /* font-size: 2.8em; */
    /* font-size: 500px; */
}

@font-face {
    font-family: bourbon;
    /*src: url(./sansumi-demibold.ttf);*/
    /* background: url('../assets/scott-warman-h4AGlo55tTA-unsplash.png');*/
    src: url('../css/BourbonW00Regular.ttf');
}
</style>